export const getModifierKey = (): string => {
    const platform = navigator.platform.toLowerCase();
    const isMac = platform.includes('mac') || platform.includes('darwin');
    return isMac ? 'CMD' : 'CTRL';
};

export const isMacPlatform = (): boolean => {
    const platform = navigator.platform.toLowerCase();
    return platform.includes('mac') || platform.includes('darwin');
};